const allowedFileTypes = '.docx,.doc,.doc2,.pptx,.xlsx,.xls,.xls2,.ppt,.email,' +
  '.pdf,.audio_mp3,.jpeg,.png,.svg,.text_plain,.text_rich,.video_avi,.video_mp4,.video_quicktime,.mp3,.mp4,' +
  '.psd,.wmf,.mpp,.wav,.gif,.tiff,.odt,.zip7,.docm,.svd,.xps,.msg,.xml,' +
  '.jpeg,.png,.svg, .eml, .rtf, .7z, .ppt, .vob, .eml, .mpp, .err';

export default  allowedFileTypes;